﻿import common = require('../ts/common');
import config = require('./modules/config');
import utilities = require('./modules/utilities');

declare function require(name: string): any;

//var jsClasses = require('../../js/jsClasses');
//var jsUtilities = require('../../js/jsUtilities');
namespace Core {
    export class ConfigurationManager {
        current() { return config };
    }
    export class CheckboxBehaviorModes {

        public static nothingOrOne = 'nothingOrOne';
        public static nothingOrMany = 'nothingOrMany';
        public static oneOnly = 'oneOnly';
        public static oneOrMany = 'oneOrMany';

        public static isValid(mode?: string) {
            return mode === CheckboxBehaviorModes.nothingOrMany ||
                mode === CheckboxBehaviorModes.nothingOrOne ||
                mode === CheckboxBehaviorModes.oneOrMany ||
                mode === CheckboxBehaviorModes.oneOnly;
        }

        public static assertIsValid(mode?: string) {
            if (!CheckboxBehaviorModes.isValid(mode))
                throw "Le mode de comportement de la checkbox '" + (mode || 'non-définit') + "' n'est pas valide.";
        }
    }
    /* Core...

          ******* DROPDOWN CONTROL *********
        Control custom de dropdown agreable sur mobile.

        Les instances de ces controles sont initialisées à l'aide de utilities.initializeDropdownControls(), via le fichier _Dropdown.cshtml

        Animation :
        - Les animations sont desactivees en raison d'un probleme en lien avec les delais.

        Configuration :
        - collapsedPageContentTarget (optionel) : selecteur qui identifie l'element a fermer lorsque la popup est ouverte (correspond normalement à la racine de la page de contenu)
        - selectId (optionel) : id du champs select
        - labelId (optionel) : id du label pointant sur le champ select,
        - bgTarget (optionel) : selecteur du background a desactiver
        - skinOptions (optionel) : options pour le rendu (fonctions avancées)
        - initializeOnCreation (optionel): function éxécutée au moment de l'initialisation
    */

    /** !!ATTENTION!! Necessite 1ms pour s'initialiser correctement en raison de la collect des textes par défaut des boutons Accepter et Refuser. */
    export class ConfirmationPopup {

        // default values
        private _bgTarget = 'body';
        private _bgActiveCssClass = 'dawn';
        private _popupTarget = '#MainConfirmPopup.mod-popup';
        private _acceptButtonTarget = '.mpop-button.accept';
        private _cancelButtonTarget = '.mpop-button.cancel';
        private _buttonTextTarget = '.mbtn-text';
        private _titleTarget = '.mpop-title';
        private _messageTarget = '.mpop-messages p';
        private _aloneApplyButtonText = "Ok";

        // initialized by default
        private _hideOnAccept = true;
        private _initBindingClick = false;
        private _alwaysRebindingClick = false;
        private _isOpen = false;
        private _onShow = null as () => void;
        private _onApply = null as () => void | boolean;
        private _onCancel = null as () => void | boolean;
        private _defaultApplyButtonText: string = null;
        private _defaultCancelButtonText: string = null;

        constructor(popupTarget?: string, titleTarget?: string, messageTarget?: string, applyButtonTarget?: string, cancelButtonTarget?: string, bgTarget?: string, bgActiveCssClass?: string) {
            if (bgTarget) this._bgTarget = bgTarget;
            if (bgActiveCssClass) this._bgActiveCssClass = bgActiveCssClass;
            if (popupTarget) this._popupTarget = popupTarget;
            if (applyButtonTarget) this._acceptButtonTarget = applyButtonTarget;
            if (cancelButtonTarget) this._cancelButtonTarget = cancelButtonTarget;
            if (titleTarget) this._titleTarget = titleTarget;
            if (messageTarget) this._messageTarget = messageTarget;

            this.get$bg().removeClass(this._bgActiveCssClass);
            this.get$popup().hide();
            this._defaultApplyButtonText = this.get$applyButtonText().text();
            this._defaultCancelButtonText = this.get$cancelButtonText().text();
        }

        private get$popup() { return $(this._popupTarget).first(); }
        private get$bg() { return $(this._bgTarget).first(); }
        private get$title() { return this.get$popup().find(this._titleTarget).first(); }
        private get$message() { return this.get$popup().find(this._messageTarget).first(); }
        private get$applyButton() { return this.get$popup().find(this._acceptButtonTarget).first(); }
        private get$cancelButton() { return this.get$popup().find(this._cancelButtonTarget).first(); }
        private get$applyButtonText() { return this.get$applyButton().find(this._buttonTextTarget).first(); }
        private get$cancelButtonText() { return this.get$cancelButton().find(this._buttonTextTarget).first(); }

        isOpen() {
            return this._isOpen;
        }
        alwaysRebindingClick(value?: boolean) {
            this._alwaysRebindingClick = value !== false;
            return this;
        }
        showWithCancelAction(onCancel?: () => void | boolean) {
            this.show(null, null, null, onCancel);
            return this;
        }
        showWithAction(onApply?: () => void | boolean, onCancel?: () => void | boolean) {
            this.show(null, null, onApply, onCancel);
            return this;
        }
        onShow(action?: () => void) {
            this._onShow = action || null;
            return this;
        }
        hideOnAccept(value?: boolean) {
            this._hideOnAccept = value !== false;
            return this;
        }
        setHtmlTitle(htmlTitle: string, titleHtmlTarget?: string) {
            this.get$popup().find(titleHtmlTarget || '.mpop-title').html(htmlTitle);
            return this;
        }
        setHtmlMessage(htmlText: string, messageHtmlTarget?: string) {
            this.get$popup().find(messageHtmlTarget || '.mpop-messages').html(htmlText);
            return this;
        }
        updateButtonText(isAloneButton: boolean, applyButtonText?: string, cancelButtonText?: string) {
            this.get$applyButtonText().text(applyButtonText || (isAloneButton ? this._aloneApplyButtonText : this._defaultApplyButtonText));
            this.get$cancelButtonText().text(cancelButtonText || this._defaultCancelButtonText);
        }
        show(title?: string, message?: string, onApply?: () => void | boolean, onCancel?: () => void | boolean, hideCancelButton?: boolean, applyButtonText?: string, cancelButtonText?: string) {
            this._onApply = onApply || null;
            this._onCancel = onCancel || null;

            if (title) this.get$title().html(title);
            if (message) this.get$message().html(message);

            this.get$bg().addClass(this._bgActiveCssClass);
            this.get$popup().show();

            this.updateButtonText(hideCancelButton === true, applyButtonText, cancelButtonText);

            if (this._onShow)
                this._onShow();

            const cancelButton = this.get$cancelButton();

            if (hideCancelButton)
                cancelButton.hide();
            else
                cancelButton.show();

            if (this.bindClick()) {
                this.get$applyButton().off('click').on('click', () => { this.onApplyClick(); });
                cancelButton.off('click');
                if (!hideCancelButton)
                    cancelButton.on('click', () => { this.onCancelClick(); });
            }

            this._isOpen = true;
            return this;
        }
        hide() {
            setTimeout(() => {
                this.get$popup().hide();
                this.get$bg().removeClass(this._bgActiveCssClass);
                if (this._alwaysRebindingClick) {
                    this.get$applyButton().off('click');
                    this.get$cancelButton().off('click');
                }
                this._isOpen = false;
            }, 1);
            return this;
        }

        private bindClick() {
            return !this._initBindingClick || this._alwaysRebindingClick;
        }

        protected onAction(isAccepted: boolean, close?: boolean) {
            if (isAccepted && !this._hideOnAccept)
                return;
            if (close !== false)
                this.hide();
        }

        private onApplyClick() {
            var close = true;
            if (this._onApply)
                close = this._onApply() !== false;
            this.onAction(true, close);
        }

        private onCancelClick() {
            var close = true;
            if (this._onCancel)
                close = this._onCancel() !== false;
            this.onAction(false, close);
        }
    }

    export class ActionsPopup {
        //private $ = (window as any).jQuery;
        private _$bg: JQuery;
        private _$popup: JQuery;
        private _$title: JQuery;
        private _$message: JQuery;
        private _onShow = null;
        private _buttons = [];
        private _callbacks = {} as any;
        private _bgActiveCssClass: any;

        constructor(popupTarget?: string, titleTarget?: string, messageTarget?: string, bgTarget?: string, bgActiveCssClass?: string) {
            if (!bgTarget) bgTarget = 'body';
            if (!bgActiveCssClass) bgActiveCssClass = 'dawn';
            if (!popupTarget) popupTarget = '#MainConfirmationPopup.mod-popup';
            if (!titleTarget) titleTarget = '.mpop-title';
            if (!messageTarget) messageTarget = '.mpop-messages p';

            this._$bg = $(bgTarget).first();
            this._$popup = $(popupTarget).first();
            this._$title = this._$popup.find(titleTarget).first();
            this._$message = this._$popup.find(messageTarget).first();
            this._$bg.removeClass(bgActiveCssClass);
            this._$popup.hide();
            this._bgActiveCssClass = bgActiveCssClass;
        }

        onShow(action: Function) {
            this._onShow = action || null;
            return this;
        }

        showWithOverridedCallbacks(overridedCallbacks: Function) {
            return this.show(null, null, overridedCallbacks);
        }

        //debug() {
        //console.log('popupTarget:');
        //console.log(popupTarget);

        //console.log('_$bg:');
        //console.log(_$bg);

        //console.log('_$popup:');
        //console.log(_$popup);

        //console.log('_$title:');
        //console.log(_$title);

        //console.log('_$message:');
        //console.log(_$message);

        //console.log('_onShow');
        //console.log(_onShow);

        //console.log('_buttons');
        //console.log(_buttons);

        //console.log('_callbacks');
        //console.log(_callbacks);
        //}

        setButtonsConfig(buttonsConfig: any[]) {
            if (!buttonsConfig) {
                //Note: Par defaut, la config est celle d'une popup de confirmation.
                buttonsConfig = [
                    {
                        target: '.mpop-button.accept',
                        callback: null
                    }, {
                        target: '.mpop-button.cancel',
                        callback: null
                    }
                ];
            }
            for (let i = 0; i < buttonsConfig.length; i++) {
                const config = buttonsConfig[i];
                const target = config.target;
                const $e = this._$popup.find(target).first();
                if (!$e) throw '[ActionsPopup::setButtonsConfig] Aucun élément trouvé pour la cible "' + target + '".';
                this._buttons[target] = {
                    $element: $e,
                    callback: config.callback || null//Note: returner 'true' pour fermer la popup
                };
            }

            return this;
        }

        show(title?: string, message?: string, overridedCallbacks?: {}) {
            if (title) this._$title.html(title);
            if (message) this._$message.html(message);

            this._$bg.addClass(this._bgActiveCssClass);
            this._$popup.show();

            if (this._onShow) this._onShow();

            for (let k in this._buttons) {
                if (!this._buttons.hasOwnProperty(k)) throw '[ActionsPopup::show] La cle "' + k + '" n\'existe pas dans l\'objet "_buttons".';
                const b = this._buttons[k];
                const uid = this._buildUid(b.$element);
                b.$element.attr('uid', uid);
                this._callbacks[uid] = overridedCallbacks && overridedCallbacks[k] ? overridedCallbacks[k] : b.callback;
                b.$element.off('click').on('click', e => {
                    const $this = $(e.currentTarget);
                    const currentUid = $this.attr('uid');
                    const callback = this._callbacks[currentUid];
                    const close = callback && callback(this);
                    if (close !== false) this.hide();
                });
            }

            return this;
        }

        setHtmlMessage(htmlText: string, messageHtmlTarget: string) {
            this._$popup.find(messageHtmlTarget || '.mpop-messages').html(htmlText);

            return this;
        }

        hide() {
            this._$popup.hide();
            this._$bg.removeClass(this._bgActiveCssClass);
            for (let k in this._buttons) {
                if (!this._buttons.hasOwnProperty(k)) throw '[ActionsPopup::hide] La cle "' + k + '" n\'existe pas dans l\'objet "_buttons".';
                const b = this._buttons[k];
                if (b.callback && b.callback instanceof Function)
                    b.$element.off('click');
            }

            return this;
        }

        private _buildUid($e: JQuery) {
            if (!$e)
                return null;
            const uid = (($e.attr('id') || '') + ($e.attr('class') || '')).split(' ').join('_');
            return uid;
        }
    }

    export class AjaxRequests {
        private _methods = {
            get: "GET",
            post: "POST"
        };
        private _method: string;
        private _url: string;
        private _cache = false;
        private _dataObj = null as any;
        private _dataType = null;
        private _contentType = null;
        private _processData = null;
        private _initialAction = null;
        private _successAction = null;
        private _errorAction = null;
        private _finalAction = null;

        constructor(serviceUrl: string) {
            if (!serviceUrl) throw "The argument 'url' cannot be null";

            this._url = serviceUrl;
        }

        getInitialAction = () => this._initialAction;
        getSuccessAction = () => this._successAction;
        getErrorAction = () => this._errorAction;
        getFinalAction = () => this._finalAction;

        asPostMethod = (data: any, useFormData: any) => {
            this._method = this._methods.post;

            if (useFormData) {
                this._contentType = false;
                this._processData = false;
                this._dataObj = this._toFormData(data);
            } else {
                this._contentType = 'application/json; charset=utf-8';
                this._dataObj = this._toStringData(data);
            }

            return this;
        }

        setCache = (bool: boolean) => {
            this._cache = bool;
        }
        setInitialAction = (value: () => void) => {
            this._initialAction = value;
            return this;
        }
        setSuccessAction = (value: () => void) => {
            this._successAction = value;
            return this;
        }
        setErrorAction = (value: () => void) => {
            this._errorAction = value;
            return this;
        }
        setFinalAction = (value: () => void) => {
            this._finalAction = value;
            return this;
        }
        toAjaxOptions = () => {
            const obj: any = {
                url: this._url,
                cache: this._cache
            };

            if (this._method === this._methods.post) obj.type = this._methods.post;
            if (this._processData !== null) obj.processData = this._processData;
            if (this._contentType !== null) obj.contentType = this._contentType;
            if (this._dataType !== null) obj.dataType = this._dataType;
            if (this._dataObj !== null) obj.data = this._dataObj;

            return obj;
        }

        private _toFormData(data?: any) {
            const form = new FormData();

            for (let k in (data || {}))
                form.append(k, data[k]);

            return form;
        }

        private _toStringData(data: any) {
            const value = JSON.stringify(data);
            return value;
        }
    }
    export class MessageNotificationDisplayConfig implements common.IMessageNotificationDisplayConfig {
        isHtmlMessage?: boolean;
        index?: number;
        focusMessage?: boolean;
        focusDelay?: number;
    }

    export class MessageNotificationConfig implements common.IMessageNotificationConfig {

        private _rootId = 'MessageNotification';
        focus = false;
        isHtmlMessage = false;
        index = null;
        defaultFocusMessage = null;
        defaultFocusDelay = null;
        scrollToMessages = false;
        textTarget = '.mmn-text';
        closerTarget = '.mmn-closer';
        rootCssClassesFormat = 'mod-message-notification {type}';
        initialDelay = 0;
        defaultFadeOutDelay = null;//Note : aucun auto-fadeout lorsque NULL.
        defaultFadeOutDuration = 1250;
        //ATTENTION: 'fixedIfNotVisible' ne fonctionne pas dans les listes Angular car il y a alteration du DOM a l'initialisation.
        fixedIfNotVisible = false;
        fixedCssClass = 'fixed';
        constructor(rootId?: string) {
            this._rootId = rootId || null;
        }
        getRootId() {
            if (!this._rootId)
                throw "[UPA::MessageNotificationConfig] La propriété 'rootId' n'a pas été définie.";
            return this._rootId;
        }
        setRootId(id: string) {
            if (!id)
                throw "[UPA::MessageNotificationConfig] La propriété 'rootId' n'est pas définie.";
            this._rootId = id;
            return this;
        }
    }

    export class MessageNotification {
        private _utilities = require('./modules/utilities');

        private _isVisible = false;
        private _delaiFunc = [];
        private _fadeOutFunc = [];
        private _typePlaceholder = '{type}';
        private _successCssClassExtension = 'success';
        private _warningCssClassExtension = 'warning';
        private _errorCssClassExtension = 'error';
        private _config: common.IMessageNotificationConfig;
        private _rootTarget: string;
        private _$beforeElement: JQuery;
        private _specificEventId: string;

        constructor(config: common.IMessageNotificationConfig, rootId?: string) {

            this._config = utilities.appendValues(config, new MessageNotificationConfig()) as common.IMessageNotificationConfig;

            if (rootId)
                this._config.setRootId(rootId);
            else if (!this._config.getRootId())
                throw "[UPA::MessageNotificationConfig] La configuration 'rootId' est requise.";

            this._rootTarget = "#" + this._config.getRootId();

            this._specificEventId = 'upaMessageNotification_' + this._config.getRootId();

            if (this._config.fixedIfNotVisible) {
                const $root = this.getRoot();
                const selector = '<span id="' + this._config + '_Ref" class="mod-message-notification-ref"></span>';
                this._$beforeElement = $(selector).insertBefore($root);
            }
        }

        getConfig() {
            return this._config;
        }

        reset(fadeOutDuration?: number) {
            const $root = this.getRoot();
            return this.hide($root, fadeOutDuration);
        }

        displayErrors(errors: common.IError[], includeErrorCode?: boolean, focusMessage?: boolean, focusDelay?: number, fadeOutDelay?: number, fadeOutDuration?: number) {
            errors = errors || [];
            const messages = [];
            for (let i = 0; i < errors.length; i++) {
                const error = errors[i];
                var message = error.message;
                if (includeErrorCode === true && error.code)
                    message += ' (' + error.code + ')';
                messages.push(message);
            }
            const config = this.buildDefaultDisplayConfig(focusMessage, focusDelay, fadeOutDelay, fadeOutDuration);
            return this.display(this.buidMessagesAsHtml(messages), this._errorCssClassExtension, config);
        }

        displaySuccessMessages(messages: string[], focusMessage?: boolean, focusDelay?: number, fadeOutDelay?: number, fadeOutDuration?: number) {
            return this.displaySuccessMessage(this.buidMessagesAsHtml(messages), focusMessage, focusDelay, fadeOutDelay, fadeOutDuration);
        }

        displayErrorMessages(messages: string[], focusMessage?: boolean, focusDelay?: number, fadeOutDelay?: number, fadeOutDuration?: number) {
            return this.displayErrorMessage(this.buidMessagesAsHtml(messages), focusMessage, focusDelay, fadeOutDelay, fadeOutDuration);
        }

        displayWarningMessages(messages: string[], focusMessage?: boolean, focusDelay?: number, fadeOutDelay?: number, fadeOutDuration?: number) {
            return this.displayWarningMessage(this.buidMessagesAsHtml(messages), focusMessage, focusDelay, fadeOutDelay, fadeOutDuration);
        }

        displaySuccessMessage(message: string, focusMessage?: boolean, focusDelay?: number, fadeOutDelay?: number, fadeOutDuration?: number) {
            const config = this.buildDefaultDisplayConfig(focusMessage, focusDelay, fadeOutDelay, fadeOutDuration);
            return this.display(message, this._successCssClassExtension, config);
        }

        displayErrorMessage(message: string, focusMessage?: boolean, focusDelay?: number, fadeOutDelay?: number, fadeOutDuration?: number) {
            const config = this.buildDefaultDisplayConfig(focusMessage, focusDelay, fadeOutDelay, fadeOutDuration);
            return this.display(message, this._errorCssClassExtension, config);
        }

        displayWarningMessage(message: string, focusMessage?: boolean, focusDelay?: number, fadeOutDelay?: number, fadeOutDuration?: number) {
            const config = this.buildDefaultDisplayConfig(focusMessage, focusDelay, fadeOutDelay, fadeOutDuration);
            return this.display(message, this._warningCssClassExtension, config);
        }

        displaySuccessMessageWithConfig(message: string, config?: common.IMessageNotificationDisplayConfig) {
            return this.display(message, this._successCssClassExtension, config);
        }

        displayErrorMessageWithConfig(message: string, config?: common.IMessageNotificationDisplayConfig) {
            return this.display(message, this._errorCssClassExtension, config);
        }

        displayWarningMessageWithConfig(message: string, config?: common.IMessageNotificationDisplayConfig) {
            return this.display(message, this._warningCssClassExtension, config);
        }

        private buildDefaultDisplayConfig(focusMessage?: boolean, focusDelay?: number, fadeOutDelay?: number, fadeOutDuration?: number) {
            const c = {
                isHtmlMessage: true,
                index: null,
                focusMessage: focusMessage || this._config.defaultFocusMessage,
                focusDelay: focusDelay || this._config.defaultFocusDelay,
                fadeOutDelay: fadeOutDelay || this._config.defaultFadeOutDelay,
                fadeOutDuration: fadeOutDuration || this._config.defaultFadeOutDuration
            } as common.IMessageNotificationDisplayConfig;
            return c;
        }
        private initCloser($root: JQuery) {
            $root.find(this._config.closerTarget).on('click', e => {
                this.onCloserClick(e.currentTarget);
            });
            return this;
        }

        private onCloserClick(element: Element) {
            const $closer = $(element).closest(this._rootTarget);
            this.hide($closer, this._config.defaultFadeOutDuration);

            if (this._$beforeElement)
                this._$beforeElement.height(0);

            this.unbindScrollEvent();

            return this;
        };

        private unbindScrollEvent() {
            this.bindScrollEvent(null, true);
        }

        private bindScrollEvent(onScroll?: (scrollEvent?: any) => void, unbindOnly?: boolean) {

            if (!this._config.fixedIfNotVisible)
                return;

            const $w = $(window);
            const scrollEventName = 'scroll.' + this._specificEventId;
            const resizeEventName = 'resize.' + this._specificEventId;

            $w.off(scrollEventName).off(resizeEventName);

            if (unbindOnly)
                return;

            $w.on(scrollEventName, onScroll).on(resizeEventName, onScroll);
        }

        private getRoot() {
            return $(this._rootTarget).first();
        }

        private buidMessagesAsHtml(messages: string[]) {
            messages = messages || [];
            var html = '';
            for (let i = 0; i < messages.length; i++)
                html += '<p>{t}</p>'.replace('{t}', messages[i]);
            return html;
        }

        private display(message: string, cssClassExtension: string, config?: common.IMessageNotificationDisplayConfig) {
            if (!config)
                config = this.buildDefaultDisplayConfig();

            if (!config.index)
                config.index = 0;

            config.isHtmlMessage = config.isHtmlMessage === true;

            if (!config.isHtmlMessage)
                message = '<p>{t}</p>'.replace('{t}', message);

            const $root = this.getRoot();
            const initialDelay = this._config.initialDelay;
            const delai = config.fadeOutDelay;
            const duration = config.fadeOutDuration;

            this.initCloser($root);

            const f = () => {

                $root.find(this._config.textTarget).html(message);

                if (this._config.rootCssClassesFormat)
                    $root.attr('class', this._config.rootCssClassesFormat.replace(this._typePlaceholder, cssClassExtension));

                this.setupFixedBehavior($root);

                $root.show();

                this.clearTimeoutFunc(config.index);

                if (delai)
                    this._delaiFunc[config.index] = setTimeout(() => {
                        this.hide($root, duration, config.index);
                    }, delai);

                const focusMessage = config.focusMessage === true;

                if (focusMessage) {
                    const focusDelay = config.focusDelay || 375;

                    this._utilities.scrollTo($root, focusDelay);
                }

                this._isVisible = true;
            }

            setTimeout(f, initialDelay);

            return this;
        }

        private setupFixedBehavior($root: JQuery) {
            if (!this._config.fixedIfNotVisible)
                return;

            const f = () => {
                const isVisible = false;
                var h: number;
                if (isVisible) {
                    h = 0;
                    $root.removeClass(this._config.fixedCssClass);
                } else {
                    h = $root.height();
                    $root.addClass(this._config.fixedCssClass);
                }
                if (this._$beforeElement)
                    this._$beforeElement.height(h);
            };

            f();

            this.bindScrollEvent(f);
        }
        private hide($root: JQuery<Element>, fadeOutDuration?: number, index?: number) {
            if (!this._isVisible)
                return this;
            index = index || 0;
            fadeOutDuration = fadeOutDuration || 0;
            this.clearTimeoutFunc(index);
            this._fadeOutFunc[index] = setTimeout(() => {
                $root.hide();
                this._isVisible = false;
            }, fadeOutDuration + 1);
            $root.fadeOut(fadeOutDuration);
            return this;
        }

        private clearTimeoutFunc(index?: number) {
            if (!index) index = 0;
            clearTimeout(this._delaiFunc[index]);
            clearTimeout(this._fadeOutFunc[index]);
            return this;
        }
    }

    export class Loader {
        private _defaultMaxDurationMs = config.loader.defaultMaxDurationMs;
        private _modCssClass = 'mod-loader';
        private _modOptDisableZoneCssClass = 'disable-zone';
        private _modVarFixedCssClass = 'fixed';
        //private _loadingCssClass = 'mldr-image';
        private _bg: JQuery;
        private _maxDuration: number;
        private _onTimeout: () => void;
        private _taskId: number = null;
        private _hiddenContentTarget: string = null;
        private _isFixed?: boolean = false;
        private _disableBgZone: boolean = false;

        constructor(private loadingTarget?: string, private bgTarget?: string, disableBgZone?: boolean, isFixed?: boolean, maxDurationMs?: number, onTimeout?: () => void) {
            //utilise le module CSS "mod-loader".
            this._bg = $(bgTarget || 'body');

            if (isFixed === true || isFixed === false)
                this._isFixed = isFixed;

            if (disableBgZone === true || disableBgZone === false)
                this._disableBgZone = disableBgZone;

            this.setMaxDurationMs(maxDurationMs);
            this.setOnTimeout(onTimeout);
        }

        setHiddenContentTarget(target: string) {
            if (target)
                this._hiddenContentTarget = target;
            return this;
        }

        setOnTimeout(action: () => void) {
            this._onTimeout = action || null;
            return this;
        }

        setMaxDurationMs(ms: number) {
            this._maxDuration = !ms && ms !== 0 ? this._defaultMaxDurationMs : ms;
            return this;
        }

        private getLoaderElement() {
            var loader = $(this.loadingTarget);
            if (!loader.length)
                loader = $('#Loading');

            return loader;
        }

        show(applyMaxDuration?: boolean) {
            this.cleanup();
            this._bg.addClass(this._modCssClass);
            if (this._isFixed)
                this._bg.addClass(this._modVarFixedCssClass);
            this.hideReferenceContent();
            if (this._disableBgZone === true)
                this._bg.addClass(this._modOptDisableZoneCssClass);
            else
                this._bg.removeClass(this._modOptDisableZoneCssClass);
            this.getLoaderElement().show();
            if (applyMaxDuration !== false && this._maxDuration) {
                if (this._taskId) clearTimeout(this._taskId);
                this._taskId = window.setTimeout(() => {
                    if (this._onTimeout) this._onTimeout();
                    this.hide();
                }, this._maxDuration);
            }
            return this;
        }

        hide() {
            this.cleanup();
            this.showReferenceContent();
            this.getLoaderElement().hide();
            return this;
        }

        private cleanup() {
            this._bg
                .removeClass(this._modCssClass)
                .removeClass(this._modVarFixedCssClass);
        }

        private hideReferenceContent() {
            if (!this._hiddenContentTarget) return;
            $(this._hiddenContentTarget).hide();
        }

        private showReferenceContent() {
            if (!this._hiddenContentTarget) return;
            $(this._hiddenContentTarget).show();
        }
    }

    export class Error implements common.IError {
        code: number;
        message: string;
        isSystemError: boolean;
        formFieldReferences?: common.IFormFieldReference[];

        constructor(message?: string, code?: number, formFieldReferences?: common.IFormFieldReference[]) {
            this.code = code || 0;
            this.message = message || 'Erreur inconnue';
            this.formFieldReferences = formFieldReferences || [];
        }

        toObject() {
            return {
                Code: this.code,
                Message: this.message
            } as Object;
        }

        toArray() {
            return [this];
        }
    }

    export class Mover {
        private _utilities = require('./modules/utilities');
        private _$root: JQuery;
        private _modTarget: string;
        private _clickTarget: string;
        constructor(modTarget?: string, clickTarget?: string) {
            this._modTarget = modTarget || 'mod-mover[mover]';
            this._clickTarget = clickTarget || '.mmv-button';
            this.init();
        }

        init() {
            this._$root = $(this._modTarget);
            this._$root.find(this._clickTarget).on('click', e => {
                //var $this = $(e.currentTarget);
                this.move();
            });
        }

        move() {
            const target = this.getTarget();
            const duration = this.getDuration();
            const offset = this.getOffset();
            this.scrollTo(target, duration, offset);
        }

        show() {
            this._$root.show();
        }

        hide() {
            this._$root.hide();
        }

        $mod() {
            return this._$root;
        }

        private getOffset() {
            const value = this._$root.attr('mover-offset');
            return parseInt(value || '0');
        }
        private getDuration() {
            const value = this._$root.attr('mover-duration');
            return parseInt(value || '0');
        }
        private getTarget() {
            const value = this._$root.attr('mover-target');
            if (!value) throw "[Mover] L'attribut 'mover-target' est requis.";
            return value;
        }

        private scrollTo(target: string, duration: number, offset: number) {
            const $target = $(target);
            this._utilities.scrollTo($target, duration, offset);
        }
    }

    export class DropdownControlConfig {
        modTarget: string;
    }

    export class DropdownControl {
        /* Control custom de dropdown agreable sur mobile.
     
            Les instances de ces controles sont initialisées à l'aide de utilities.initializeDropdownControls(), via le fichier _Dropdown.cshtml
     
            Animation :
            - Les animations sont desactivees en raison d'un probleme en lien avec les delais.
     
            Configuration :
            - collapsedPageContentTarget (optionel) : selecteur qui identifie l'element a fermer lorsque la popup est ouverte (correspond normalement à la racine de la page de contenu)
            - selectId (optionel) : id du champs select
            - labelId (optionel) : id du label pointant sur le champ select,
            - bgTarget (optionel) : selecteur du background a desactiver
            - skinOptions (optionel) : options pour le rendu (fonctions avancées)
            - initializeOnCreation (optionel): function éxécutée au moment de l'initialisation
        */
        private _isInit = false;
        private _config: any;
        private _defaultInitializeOnCreation = true;
        private _defaultBgTarget = 'body';
        private _dropdownCollapseAttribute = 'dropdown-collapse';
        private _collapsedPageContentCssClass = 'collapsed';
        private _lastOffsetY: number = null;
        private _$select: JQuery;
        private _$label: JQuery;
        private _$selectedItem: JQuery;
        private _$popup: JQuery;
        private _$popupCloser: JQuery;
        private _$popupItems: JQuery;
        private _collapseStates = {
            opened: 'opened',
            closed: 'closed'
        };
        //private _animationCssClass = 'with-animation';
        //private _animationOptions = {
        //    veryFast: "VeryFast",
        //    fast: "Fast",
        //    normal: "Normal",
        //    slow: "Slow",
        //    verySlow: "VerySlow",
        //};
        private _selectedItemMarkupTemplate = '\
<span id="{id}" class="mod-mobile-friendly-dropdown-seletion" dropdown-is-readonly="{isReadOnly}"{toolTips}><span class="mmfds-text" dropdown-text>{text}</span><span class="mmfds-icon"></span></span>\
';
        private _itemMarkupTemplate = '\
<li class="mmfd-item" dropdown-item dropdown-status="{status}" dropdown-value="{value}">\
    <span class="mmfd-item-label">{text}</span><span class="mmfd-item-icon"></span>\
</li>\
';
        private _moduleMarkupTemplate = '\
<section id="{id}" class="mod-mobile-friendly-dropdown{cssOptions}" dropdown-collapse="{collapse}">\
    <div class="mmfd-container">\
        <h1 class="mmfd-title">{title}</h1>\
        <ul class="mmfd-items">\
            {items}\
        </ul>\
        <div class="mmfd-closer" title="Cliquer pour annuler le changement" dropdown-closer></div>\
    </div>\
</section>\
';
        private _popupData = {
            isOpened: false,
            isReadOnly: false,
            selectedItemId: null,
            id: null,
            title: '',
            items: []
        };

        constructor(config?: any) {
            //new Classes.
            this.setConfiguration(config);
            if (this._config.initializeOnCreation)
                this.init();
        }

        isInit() {
            return this._isInit;
        }

        init() {
            if (this.isInit())
                return this;
            this._isInit = true;

            this._$select = $('#' + this._config.selectId);
            this._$label = $('#' + this._config.labelId);

            this.updatePopupData();
            this.buildUi();
            return this;
        }

        reinit(config?: any) {
            this._isInit = false;
            this.setConfiguration(config);
            this.init();
        }

        getCurrentPopupData() {
            return this._popupData;
        }

        open() {
            if (this._popupData.isReadOnly)
                return this;
            this._$popup.attr(this._dropdownCollapseAttribute, this._collapseStates.opened);
            this.collapsePageContent();
            this._popupData.isOpened = true;
            return this;
        }

        close() {
            this._$popup.attr(this._dropdownCollapseAttribute, this._collapseStates.closed);
            this.uncollapsePageContent();
            this._popupData.isOpened = false;
            return this;
        }

        onSelectClick($select: JQuery) {
            this.open();
            return this;
        }

        onCloserClick($closer: JQuery) {
            this.close();
            return this;
        }

        onItemClick($item: JQuery) {
            const itemValue = this.getItemValue($item);
            const $options = this._$select.find('option');
            var $selectedOption: JQuery = null;
            for (let i = 0; i < $options.length; i++) {
                const $o = $($options[i] as any);
                const v = $o.attr('value');
                if (v === itemValue) {
                    $selectedOption = $o;
                    $o.attr('selected', 'selected');
                } else {
                    $o.removeAttr('selected');
                }
            }

            if (!$selectedOption)
                throw "MobileFriendlyDropdown: Aucune option n'a été trouvée pour la valeur '" + itemValue + "'.";

            this.unselectAllItems(($e: JQuery) => {
                return $e !== $item;
            });

            this.updateSelectedItem($selectedOption);

            this.close();

            setTimeout(() => {
                this._$select.change();
            }, 1);

            return this;
        }

        updateSelectedItem($option: JQuery) {
            const text = $option.html();
            this._$selectedItem.find('[dropdown-text]').html(text);
        }

        unselectAllItems(where?: ($e: JQuery) => boolean) {
            where = where || (() => true);
            for (let i = 0; i < this._$popupItems.length; i++) {
                const $item = $(this._$popupItems[i] as any);
                const unselectThis = where($item);
                this.setAsActive($item, !unselectThis);
            }
        }

        updatePopupData() {
            this._popupData.selectedItemId = this._config.selectId + '_SelectedValue';
            this._popupData.id = this._config.selectId + '_Popup';
            this._popupData.title = this._$label.html();
            this._popupData.items = [];
            this._popupData.isOpened = false;
            this._popupData.isReadOnly = this._$select.attr('readonly') === 'readonly';
            const $options = this._$select.find('option');
            for (let i = 0; i < $options.length; i++) {
                const $thisOption = $($options[i] as any);
                const value = $thisOption.attr('value');
                const isSelected = $thisOption.attr('selected') === 'selected';
                const text = $thisOption.html();
                this._popupData.items.push({
                    value: value,
                    text: text,
                    isSelected: isSelected
                });
            }
            return this;
        }

        buildUi() {
            var itemsMarkup = '', markup = '';
            var selectedItem: any = null;
            for (let i = 0; i < this._popupData.items.length; i++) {
                const item = this._popupData.items[i];
                if (!selectedItem && item.isSelected)
                    selectedItem = item;
                const itemMarkup = this._itemMarkupTemplate
                    .replace('{status}', item.isSelected ? 'selected' : '')
                    .replace('{value}', item.value)
                    .replace('{text}', item.text);
                itemsMarkup += itemMarkup;
            }
            const selectedText = (() => {
                if (selectedItem) {
                    return selectedItem.text;//from selected option
                } else if (this._popupData.items.length) {
                    return this._popupData.items[0].text; //from first item
                } else {
                    return 'Aucun item sélectionné';//default
                }
            })();

            const selectedItemMarkup = this._selectedItemMarkupTemplate
                .replace('{id}', this._popupData.selectedItemId)
                .replace('{isReadOnly}', this._popupData.isReadOnly ? 'true' : 'false')
                .replace('{toolTips}', this._popupData.isReadOnly ? ' title="Ce champ est en lecure seulement"' : '')
                .replace('{text}', selectedText);

            var animationCssOption = null;
            //if (this._config.animationOption)
            //    animationCssOption = (x => {
            //        x += ' ' + this._animationCssClass;
            //        if (this._config.animationOption === this._animationOptions.veryFast)
            //            x += ' very-fast';
            //        if (this._config.animationOption === this._animationOptions.fast)
            //            x += ' fast';
            //        if (this._config.animationOption === this._animationOptions.normal)
            //            x += ' normal';
            //        if (this._config.animationOption === this._animationOptions.slow)
            //            x += ' slow';
            //        if (this._config.animationOption === this._animationOptions.verySlow)
            //            x += ' very-slow';
            //        return x;
            //	})('');

            var cssOptions = '';

            if (animationCssOption) {
                cssOptions += animationCssOption;

                if (this._config.collapsedPageContentTarget)
                    $(this._config.collapsedPageContentTarget)
                        .addClass(this._config.collapsedPageContentCssClass);
            }

            for (let i = 0; i < this._config.skinOptions.length; i++) {
                const o = this._config.skinOptions[i];
                cssOptions += ' ' + o;
            }

            const initialCollapseState = this._collapseStates.closed;

            markup = this._moduleMarkupTemplate
                .replace('{id}', this._popupData.id)
                .replace('{title}', this._popupData.title)
                .replace('{items}', itemsMarkup)
                .replace('{collapse}', initialCollapseState)
                .replace('{cssOptions}', cssOptions);

            this._$selectedItem = $(selectedItemMarkup);

            this._$selectedItem.on('click', () => {
                //redirect click and change event
                this._$select.trigger('click');
            });

            this._$select.hide().on('click', e => {
                const $this = $(e.currentTarget as any);
                this.onSelectClick($this);
            }).parent().prepend(this._$selectedItem);

            this._$popup = $(markup);

            this._$popupCloser = this._$popup.find('[dropdown-closer]').on('click', e => {
                const $this = $(e.currentTarget as any);
                this.onCloserClick($this);
            });

            this._$popupItems = this._$popup.find('[dropdown-item]').on('click', e => {
                const $this = $(e.currentTarget as any);
                this.onItemClick($this);
            });

            $(this._config.bgTarget).append(this._$popup);

            return this;
        }

        private collapsePageContent() {
            if (!this._config.collapsedPageContentTarget)
                return false;

            this._lastOffsetY = this.topOffset();

            $(this._config.collapsedPageContentTarget)
                .css('height', 0)
                .css('overflow', 'hidden')
                .addClass(this._collapsedPageContentCssClass);

            return true;
        }

        private uncollapsePageContent() {
            if (!this._config.collapsedPageContentTarget)
                return false;

            $(this._config.collapsedPageContentTarget)
                .css('height', 'auto')
                .css('overflow', 'auto')
                .removeClass(this._collapsedPageContentCssClass);

            if (this._lastOffsetY || this._lastOffsetY === 0)
                this.goTo(this._lastOffsetY);

            return true;
        }

        private setConfiguration(config?: any) {
            this._config = config ||
            {
                collapsedPageContentTarget: null,
                selectId: null,
                labelId: null,
                bgTarget: null,
                skinOptions: [],
                //animationOption: null,
                initializeOnCreation: this._defaultInitializeOnCreation
            };

            if (!this._config.selectId)
                throw "L'argument 'selectId' est requis.";
            if (!this._config.labelId)
                throw "L'argument 'labelId' est requis.";
            if (!this._config.bgTarget)
                this._config.bgTarget = this._defaultBgTarget;
            if (!this._config.skinOptions)
                this._config.skinOptions = [];
            if (this._config.initializeOnCreation !== false && this._config.initializeOnCreation !== true)
                this._config.initializeOnCreation = this._defaultInitializeOnCreation;
            //if (!this._config.animationOption)
            //    this._config.animationOption = this._animationOptions.fast;
        }

        private getSelectedItem() {
            for (let i = 0; i < this._popupData.items.length; i++) {
                const item = this._popupData.items[i];
                if (item.isSelected)
                    return item;
            }
            return null;
        }

        private setAsActive($item: JQuery, status?: boolean) {
            status = status !== false;
            $item.attr('dropdown-status', status ? 'selected' : '');
            return this;
        }

        private getItemValue($item: JQuery) {
            const v = $item.attr('dropdown-value') || '';
            return v;
        }

        //UTILITIES

        //Car il n'est pas possible ici d'importer les 'utilities' via required.
        private topOffset() {
            return $(window.document as any).scrollTop();
        }
        private goTo(y: number, animationDuration?: number, easing?: string, callback?: () => void) {
            const min = 1;
            const $e = $('html, body');
            if (!animationDuration) {
                $e.scrollTop(y);
            } else {
                const d = Math.max(animationDuration, min);
                $e.animate({
                    scrollTop: y,
                    duration: d,
                    easing: easing || 'easeOutCubic',
                    complete: callback
                } as any);
            }
        }
    }
}

export = Core;